// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2TIXz","right":"styles_right__2euRi"};